<template>
    <div class="row">
        <div class="small-12 column end">
            <FormView/>
        </div>
    </div>
</template>

<script>
import FormView from './FormView';
export default {
    name: 'BaseView',
    components: {FormView}
};
</script>

<style scoped>

</style>